import { render, staticRenderFns } from "./Profile.html?vue&type=template&id=62875996&scoped=true&external"
import script from "./Profile.ts?vue&type=script&lang=ts&external"
export * from "./Profile.ts?vue&type=script&lang=ts&external"
import style0 from "./Profile.scss?vue&type=style&index=0&id=62875996&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62875996",
  null
  
)

export default component.exports